import { atom } from 'recoil';

import { DEFAULT_ALERT_STATE } from './defaults';

export const alertState = atom({
  key: 'alertState',
  default: DEFAULT_ALERT_STATE,
});
